import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import Model from './model/Model';
import styles from './Models.module.scss';
import { connect } from 'react-redux';
import {
	getModelLotsFit,
	setFilteredLots,
	setLotSelectedId,
	setLotSizeType,
} from '../../../../redux/siteplanManagement/action';
import {
	getLots,
	getBuildingInfo,
	setLotWithModelSelected,
} from '../../../../redux/siteplanManagement/action';
import getModelLots from '../../../../api/Siteplan/getModelLots.api';
import Loading from '../../../layout/loading/Loading';

const Models = (props) => {
	const {
		// parent props
		loadedData,
		setStayHighlighted,
		// redux
		lots,
		lotSelectedId,
		userDetails,
		fitModels,
		fitLots,
		loading,
		setLotSelectedId,
		getLots,
		setLotWithModelSelected,
		getBuildingInfo,
		getModelLotsFit,
		lotSizeType,
		setLotSizeType,
		filteredLots,
		setFilteredLots,
		showAvailableLots,
	} = props;
	const [selectedModel, setSelectedModel] = useState('all');
	const [numberOfModels, setNumberOfModels] = useState(0);
	const [modelKeys, setModelKeys] = useState([]);
	const [modelsFitLot, setModelsFitLot] = useState([]);

	useEffect(() => {
		getLots(userDetails);
		getBuildingInfo();
	}, []);

	useEffect(() => {
		if (selectedModel === 'all') {
			getModelLotsFit('all');
			setLotSelectedId('');
		} else if (selectedModel === ' ') {
			getModelLotsFit(selectedModel);
		} else {
			setLotSelectedId('');
			getModelLotsFit(selectedModel);
		}
	}, [lots, selectedModel]);

	useEffect(() => {
		if (loadedData) {
			setLotWithModelSelected(loadedData);
		} else {
			setLotWithModelSelected({});
		}
	}, [loadedData]);

	useEffect(() => {
		let filtered;

		if (lotSizeType === '') {
			filtered = lots;
		} else {
			filtered = lots.filter((lot) => lot?.lotSizeType === lotSizeType);
		}

		if (lotSelectedId) {
			filtered = filtered.filter(
				(lot) => lot.lot.toString() === lotSelectedId
			);
		}

		if (showAvailableLots) {
			let filteredResult = filtered?.filter(
				(item) => item.availability === 'available'
			);
			setFilteredLots(filteredResult);
		} else {
			setFilteredLots(filtered);
		}

		let modelArr = [];
		if (filtered.length > 0) {
			filtered?.forEach((lot) => {
				lot.buildings?.forEach((building) => {
					if (!modelArr.includes(Object.keys(building)[0])) {
						modelArr.push(Object.keys(building)[0]);
					}
				});
			});

			setNumberOfModels(modelArr.length);
		} else {
			setNumberOfModels(0);
		}
		console.log('modelArrr', modelArr);
		setModelKeys(modelArr);
	}, [lots, lotSizeType, showAvailableLots, lotSelectedId]);

	useEffect(() => {
		if (lotSelectedId !== '') {
			let filteredLots = lots.filter(
				(lot) => lot?.lot === Number(lotSelectedId)
			);
			if (filteredLots.length > 0) {
				let modelArr = [];
				filteredLots.forEach((lot) => {
					lot.buildings.forEach((building) => {
						if (!modelArr.includes(Object.keys(building)[0])) {
							modelArr.push(Object.keys(building)[0]);
						}
					});
				});
				setModelsFitLot(modelArr);
				setSelectedModel(' ');
			}
		}
	}, [lotSelectedId]);

	useEffect(() => {
		return () => {
			setLotWithModelSelected({});
		};
	}, []);

	const doIHaveElevations = (elevationRestriction) => {
		var elevationRestrictionKeys = Object.keys(elevationRestriction);

		var canChooseArr = [];

		elevationRestrictionKeys.forEach((key) => {
			var canChoose = elevationRestriction[key]['canChoose'];

			if (canChoose === true) {
				canChooseArr.push(true);
			}
		});

		if (canChooseArr.length > 0) {
			return true;
		} else {
			return false;
		}
	};

	const handleLotSizeTypeSelect = (e) => {
		setLotSelectedId('');
		setStayHighlighted(false);
		setSelectedModel('all');
		let data = e.currentTarget.dataset.lotSizeType;
		console.log('data', data);
		if (data === '50') {
			setTimeout(function () {
				setStayHighlighted(true);
			}, 1000);
			if (lotSizeType !== data) {
				setLotSizeType(data);
				getModelLotsFit('all');
				setSelectedModel('all');
			} else {
				console.log('imafmaif');
				setLotSizeType('');
			}
		} else if (data === '70') {
			setTimeout(function () {
				setStayHighlighted(true);
			}, 1000);
			if (lotSizeType !== data) {
				setLotSizeType(data);
				getModelLotsFit('all');
				setSelectedModel('all');
			} else {
				setLotSizeType('');
			}
		}
	};

	const handleSelectedModel = (e) => {
		setStayHighlighted(false);
		setTimeout(function () {
			setStayHighlighted(true);
		}, 1000);
		setSelectedModel(e.target.value);
	};

	return (
		<div className={styles.models}>
			<h3 className={styles.models_title}>Available models</h3>
			<div className={styles.selector_group}>
				<div
					className={`${styles.selector_btn1}  ${
						lotSizeType === '50' ? styles.active : ''
					}`}
					data-lot-size-type='50'
					onClick={(e) => handleLotSizeTypeSelect(e)}
				>
					50' Lot
				</div>
				<div
					className={`${styles.selector_btn2}  ${
						lotSizeType === '70' ? styles.active : ''
					}`}
					data-lot-size-type='70'
					onClick={(e) => handleLotSizeTypeSelect(e)}
				>
					70' Lot
				</div>
			</div>
			<div className={styles.modelsWrapper}>
				{loading && <Loading />}
				<FormControl
					variant='outlined'
					className={styles.model_selector_form_control}
				>
					<Select
						className={styles.model_selector}
						value={selectedModel}
						onChange={handleSelectedModel}
					>
						<MenuItem value='all'>All ({numberOfModels})</MenuItem>
						{modelKeys.map((modelKey) => (
							<MenuItem value={modelKey} key={modelKey}>
								{modelKey}
							</MenuItem>
						))}
						{lotSelectedId !== '' && (
							<MenuItem value=' '>
								lot {lotSelectedId} selected
							</MenuItem>
						)}
					</Select>
				</FormControl>
			</div>
			{(parseInt(numberOfModels) === 0 ||
				parseInt(numberOfModels) === NaN) && (
				<span>No available models in 50' lot</span>
			)}
			<div>
				{selectedModel === 'all' ? (
					fitLots
						?.filter((modelObj) => {
							console.log('model object ', modelObj);
							let result = false;
							for (let key of modelKeys) {
								if (modelObj[key]) {
									result = true;
								}
							}
							return result;
						})
						?.map((modelObj) => {
							var modelKey = Object.keys(modelObj)[0];
							console.log('modelObj', modelObj);

							console.log('I am clicking here 206');

							return (
								<Model
									modelKey={modelKey}
									key={modelKey}
									choseFromModel={true}
									modelLots={modelObj?.lots}
								/>
							);
						})
				) : selectedModel === ' ' ? (
					fitModels.map((modelObj) => {
						console.log('modelKey', Object.keys(modelObj)[0]);
						var modelKey = Object.keys(modelObj)[0];
						var elevationRestriction =
							modelObj[Object.keys(modelObj)[0]];

						console.log(
							'elevatiojjjnRestriction',
							elevationRestriction
						);

						if (doIHaveElevations(elevationRestriction)) {
							return (
								<Model
									modelKey={modelKey}
									key={modelKey}
									elevationRestriction={elevationRestriction}
									lotSelectedId={lotSelectedId}
								/>
							);
						}
					})
				) : (
					<Model
						modelKey={selectedModel}
						choseFromModel={true}
						modelLots={fitLots?.length > 0 && fitLots[0].lots}
					/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	lots: state.siteplanManagement.lots,
	lotSelectedId: state.siteplanManagement.lotSelectedId,
	userDetails: state.signIn,
	fitModels: state.siteplanManagement.fitModels,
	fitLots: state.siteplanManagement.fitLots,
	loading: state.siteplanManagement.loading,
	lotSizeType: state.siteplanManagement.lotSizeType,
	filteredLots: state.siteplanManagement.filteredLots,
	showAvailableLots: state.siteplanManagement.showAvailableLots,
});

export default connect(mapStateToProps, {
	setLotSelectedId,
	getLots,
	getBuildingInfo,
	setLotWithModelSelected,
	getModelLotsFit,
	setLotSizeType,
	setFilteredLots,
})(Models);
